import React from "react";
import { createRoot } from "react-dom/client";     // React 18 entry point
import 'tailwindcss/tailwind.css';
import "bulma/css/bulma.min.css";
import "./styles/tokens.css";
import "./styles/figma-forms.css";
// import './index.css'
import App from "./App";
import { UserProvider } from "./context/UserContext";
import Sentry, { initSentry, sentryEnabled } from "./lib/sentry";

import axios from "axios";
import { getApiBase } from "./context/api";


// ── Monkey-patch fetch so that "/foo" → "https://<API_BASE>/foo" ──
const API_BASE = getApiBase();
const originalFetch = window.fetch.bind(window);



window.fetch = (resource, init) => {
    if (typeof resource === "string" && resource.startsWith("/") && API_BASE) {
      resource = `${API_BASE}${resource}`;
    }
    return originalFetch(resource, init);
  }; 


// 🌐 Patch Axios
axios.defaults.baseURL = API_BASE ? API_BASE.replace(/\/$/, '') : '';

console.log("🌐 Axios default baseURL:", axios.defaults.baseURL || "(using proxy)");

initSentry();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Sentry.ErrorBoundary
    fallback={({ error }) => (
      <div style={{ padding: "2rem", fontFamily: "sans-serif" }}>
        <h1 style={{ fontSize: "1.5rem", marginBottom: "0.75rem" }}>
          Ha ocurrido un error inesperado
        </h1>
        <p style={{ marginBottom: "1rem" }}>
          Recarga la pagina o vuelve a intentarlo en unos minutos.
        </p>
        {process.env.NODE_ENV === "development" && error ? (
          <pre style={{ whiteSpace: "pre-wrap", fontSize: "0.875rem" }}>
            {String(error)}
          </pre>
        ) : null}
        {!sentryEnabled ? (
          <p style={{ marginTop: "1rem", fontSize: "0.875rem" }}>
            Sentry no esta configurado en este entorno.
          </p>
        ) : null}
      </div>
    )}
  >
    <UserProvider>
      <App />
    </UserProvider>
  </Sentry.ErrorBoundary>
);

